<template>
  <artmisads-modal
    :open="open"
    :title="title"
    :width="720"
    :maskClosable="false"
    :footer="null"
    :onCancel="() => (open = false)"
    :destroyOnClose="true"
  >
    <artmisads-table
      v-model:pagination="pagination"
      :columns="columns"
      :data-source="dataSource"
      :change="onTableChange"
      :loading="load"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'publisher'">
          <div class="publisher-cell">
            <span class="publisher-name">{{ record.publisherName || '--' }}</span>
            <span class="publisher-email">{{ record.publisherEmail || '' }}</span>
          </div>
        </template>
        <template v-if="column.key === 'salesAmount' || column.key === 'bonusAmount'">
          {{ currencySymbol }} {{ formatAmount(record[column.key]) }}
        </template>
      </template>
    </artmisads-table>
  </artmisads-modal>
</template>

<script setup>
import { ref, reactive, computed, defineExpose } from 'vue'
import { accBonusProgramsApi } from '~/server/operator/accBonusPrograms'
import { CURRENCY_DATA_MAPPER } from '~/contants/common'

const open = ref(false)
const load = ref(false)
const dataSource = ref([])
const programId = ref('')
const currencyCode = ref('USD')
const title=ref('')
const currencySymbol = computed(() => CURRENCY_DATA_MAPPER[currencyCode.value] || '$')

const pagination = reactive({
  total: 0,
  current: 1,
  size: 10,
  pageSize: 10,
  showSizeChanger: true,
  pageSizeOptions: ['10', '20', '50'],
})

const columns = [
  {
    title: 'Publisher',
    dataIndex: 'publisher',
    key: 'publisher',
    width: 220,
  },
  {
    title: 'Sales',
    dataIndex: 'salesAmount',
    key: 'salesAmount',
  },
  {
    title: 'Bonus',
    dataIndex: 'bonusAmount',
    key: 'bonusAmount',
  },
]

const formatAmount = (val) => Number(val || 0).toFixed(2)

const fetchList = async () => {
  if (!programId.value) return
  load.value = true
  try {
    const res = await accBonusProgramsApi.getPublishers({
      programId: programId.value,
      page: pagination.current,
      size: pagination.size,
    })
    const payload = res
    dataSource.value = payload?.data ?? []
    pagination.total = payload?.total ?? dataSource.value.length
  } finally {
    load.value = false
  }
}

const onTableChange = ({ current, pageSize }) => {
  pagination.current = current
  pagination.size = pageSize
  pagination.pageSize = pageSize
  fetchList()
}

const show = (record) => {
  open.value = true
  programId.value = record.programId || record.id
  currencyCode.value = record.currency || 'USD'
  pagination.current = 1
  pagination.size = 10
  pagination.pageSize = 10
  dataSource.value = []
  title.value = record.title || ''
  fetchList()
}

defineExpose({ show })
</script>

<style lang="less" scoped>
.publisher-cell {
  display: flex;
  flex-direction: column;

  .publisher-name {
    color: var(--dark-1);
    font-weight: 600;
  }

  .publisher-email {
    color: var(--dark-3);
    font-size: 12px;
  }
}
</style>
